import { Link2, Monitor, Smartphone } from "lucide-react";
import type { ReactNode } from "react";

interface Feature {
  readonly icon: ReactNode;
  readonly index: string;
  readonly title: ReactNode;
  readonly body: string;
  readonly footnote: string;
}

const FEATURES: readonly Feature[] = [
  {
    icon: <Monitor size={24} />,
    index: "01 / On your website",
    title: (
      <>
        Make giving part
        <br />
        of your own space.
      </>
    ),
    body: "Bring a giving widget or button to the website your community already knows.",
    footnote: "Your website. A connected giving experience.",
  },
  {
    icon: <Link2 size={24} />,
    index: "02 / In every invitation",
    title: (
      <>
        A little link.
        <br />A lot of possibility.
      </>
    ),
    body: "Share a giving link in an email, or put a QR code where your community comes together.",
    footnote: "From the newsletter to the next gathering.",
  },
  {
    icon: <Smartphone size={24} />,
    index: "03 / Always with them",
    title: (
      <>
        A reason to give.
        <br />
        An easy way back.
      </>
    ),
    body: "Keep receipts, past gifts, and opportunities to give again together in the app.",
    footnote: "A relationship that lasts beyond one gift.",
  },
];

export function BeyondTheRoom() {
  return (
    <section id="beyond" className="section">
      <div className="page">
        <div className="section__heading">
          <div>
            <p className="overline">
              <span className="overline__rule" aria-hidden="true" />
              Beyond the room
            </p>
            <h2>
              The event ends.
              <br />
              <em>The generosity doesn't.</em>
            </h2>
          </div>
          <p>Be there wherever your community feels moved to give.</p>
        </div>

        <div className="beyond__grid">
          {FEATURES.map((feature) => (
            <article className="beyond__item" key={feature.index}>
              <span className="beyond__icon">{feature.icon}</span>
              <span className="beyond__index">{feature.index}</span>
              <h3>{feature.title}</h3>
              <p>{feature.body}</p>
              <div className="beyond__footnote">{feature.footnote}</div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
